import { Button, Dropdown, Icon, Layout, Menu } from 'antd'
import React from 'react'
import config from 'src/core/config'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
import { inject, observer } from '../core/store'
const { Header } = Layout
@inject('store')
@observer
export default class extends React.Component {
  async componentWillMount() {
  }
  loginOut = () => {
    localstorage.remove('userToken')
    history.push('/oauth/login/index')
  }
  goToApp = ({ key }) => {
    let indexKey = (key) ? parseInt(key) : 0
    let { list, item } = this.AppStore
    if (list[indexKey].appId !== item.appId) {
      window.location.reload()
    }
  }
  AppMenu(list, item) {
    // console.log(`list`, JSON.stringify(list), 'item', JSON.stringify(item))
    return (
      <Dropdown overlay={(
        <Menu onClick={this.goToApp}>
          {
            list && list.map((item, index) => {
              return (<Menu.Item key={index}>{item.appname}</Menu.Item>)
            })
          }
        </Menu>
      )}>
        <Button style={{ marginLeft: 16 }}>
          {(item.appname) ? item.appname : '已创建的小程序'}
          <Icon type="down" />
        </Button>
      </Dropdown>
    )
  }
  render() {
    // const { list, item } = this.AppStore
    let user = localstorage.get('userToken')
     console.log('config',config)
    return (
      <Header className="header" style={{ background: '#fff', padding: 0 }}>
        <div className="header-left">
          <div>
            <div style={{ marginLeft:"20px", color: '#ff0000' }}>{(config.host == 'https://api.superforest.vip' ) ? '正式环境' : ''}</div>
            {/* {this.AppMenu(list, item)} */}
            {/* <Button type="primary" className="create" ><Link to="/dashboard/config/app">管理应用</Link></Button> */}
          </div>
        </div>
        <div className="header-right">
          {/* <Link className="service" to={{ pathname: '/chat/main/index', query: {} }} target="_blank">客服系统</Link> */}
          {/* <ul className="docs">
            <li><Link to="">开发文档</Link></li>
            <li><Link to="">下载SDK</Link></li>
          </ul> */}
          <div className="profile">
            <Dropdown overlay={(<Menu>
              <Menu.Item key="1"><div onClick={this.loginOut}>退出账号</div></Menu.Item>
            </Menu>)} placement="bottomRight">
              <a className="ant-dropdown-link">
                <img src={user.avatarurl ? user.avatarurl : "/assets/pic_adminpic@2x.png"} className="logo" /> <Icon type="down" />
              </a>
            </Dropdown>
          </div>
        </div>

      </Header>
    )
  }
}



// WEBPACK FOOTER //
// ./layout/Header.js